import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ForgetPassword.css";
import logo from '../../assets/images/logo.png';
import { resetpassword } from "../../Services/AccountServices";

function ResetPassword() {
  const[password,setpassword]=useState("");
  const [reset, setReset] = useState({
    otp: '',
    confirmPassword: ''
  });

  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  const validatePasswords = () => {
    const errors = {};

    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (!reset.confirmPassword) { 
      errors.confirmPassword = "Confirm Password is required";
    } else if (password !== reset.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validatePasswords()) {
      try {
        await resetpassword(reset);
        setMessage("Password reset successful!");
        navigate("/login")
      } catch (error) {
        setErrors({ general: "Failed to reset password. Try again." });
        console.error(error);
      }
    }
  };

  return (
    <div className="container-fluid body vh-100 d-flex justify-content-center align-items-center">
      <div className="row w-100 justify-content-center">
        <div className="text-center pt-3 pb-3">
          <img src={logo} width={220} className="h-8" alt="Logo" />
        </div>
        <div className="col-md-4">
          <div className="forgot-form p-4 shadow-lg">
            <h3 className="text-center mb-4" style={{ fontSize: "1.3em" }}>
              Reset Password
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={reset.otp}
                  onChange={(e) => setReset({ ...reset, otp: e.target.value })}
                  required
                />
                <label htmlFor="otp">Enter OTP</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setpassword( e.target.value)}
                  required
                />
                <label htmlFor="password">Enter new password</label>
                {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
              </div>

              <div className="form-floating mb-3">
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-control"
                  placeholder="Confirm new password"
                  value={reset.confirmPassword}
                  onChange={(e) => setReset({ ...reset, confirmPassword: e.target.value })}
                  required
                />
                <label htmlFor="confirmPassword">Confirm new password</label>
                {errors.confirmPassword && <p style={{ color: "red" }}>{errors.confirmPassword}</p>}
              </div>

              {errors.general && <p style={{ color: "red" }}>{errors.general}</p>}
              {message && <p style={{ color: "green" }}>{message}</p>}

              <button type="submit" className="btn btn-primary w-100">
                Reset Password
              </button>
            </form>

            <div className="d-flex justify-content-between mt-3">
              <button
                onClick={() => navigate("/login")}
                className="btn btn-link text-primary text-decoration-none"
              >
                Back to Login?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
